module.exports = __webpack_public_path__ + "img/image15.6e0d6db9.jpeg";